import { useTranslation } from 'react-i18next'

import { Tooltip } from '@percent/lemonade'
import { ReactComponent as FeaturedStar } from '@percent/partner-dashboard/common/assets/images/featured-star.svg'
import { formatCountryNamesString } from '@percent/partner-dashboard/common/library/utility/utility'
import { getCountryNamesFromAlpha3Codes } from '@percent/partner-dashboard/i18n/countries'

type FeaturedStarTooltipProps = {
  featured?: {
    featuredItemId?: string
    country?: string[]
  }
}

export function FeaturedStarTooltip({ featured }: FeaturedStarTooltipProps) {
  const { t } = useTranslation()

  return (
    <Tooltip
      data-testid="featured-tooltip"
      content={
        featured?.country?.length
          ? t('toolTip.featured.countrySpecific', {
              countries: formatCountryNamesString(getCountryNamesFromAlpha3Codes(featured.country))
            })
          : t('toolTip.featured.global')
      }
    >
      <span data-testid="featured-star">
        <FeaturedStar />
      </span>
    </Tooltip>
  )
}
